import React from 'react';
import './Dimensions.css';

const Dimensions = (props) => {

    const {length, height} = props;
    const heightInMeters = height == "hc" ? "2.9" : height == "hh" ? "1.3" : "2.6";
    const widthInMeters = "2.4";
    const lengthInMeters = length == "20" ? "6.1" : "12.2";

    return (
        <div className='Dimensions w-100'>
            <p className="text-center no-block-start">This shipping container's dimensions: <b>L:</b> {length}ft ({lengthInMeters}m), <b>W:</b> 8ft ({widthInMeters}m), <b>H:</b> {height == "hc" ? "9.5" : height == "hh" ? "4.25" : "8.5"}ft ({heightInMeters}m)</p>
            <div className="w-100 d-flex">
                <div className="flex-1 d-flex col align-center text-center">
                    <img style={{width: "90%", maxWidth: "600px"}} src={"/assets/img/dimensions_img/"+length+height+".svg"} alt={`Chart showing ${length}ft ${height} containers compared to others.`}/><br /><br /><br /><br />
                </div>
            </div>
        </div>
    );
};

export default Dimensions;